@if (type == 'shootAssets') {
  <div
    class="qc-view"
    #pdList
    (scroll)="onScroll($event)"
    >
    @for (masterSuite of productShootAssetsResult; track masterSuite; let a = $index) {
      <div
        style="display: grid"
        >
        <h1>{{ masterSuite.masterSuiteName }}</h1>
        @for (product of masterSuite.products; track product; let b = $index) {
          <div>
            <div class="product-info">
              <span [class.product-info--missing]="!product.barcode">{{ product.barcode || '—' }}</span>
              <span class="product-info__sep">·</span>
              <span [class.product-info--missing]="!product.reference">{{ product.reference || '—' }}</span>
            </div>
            <div class="product-details-page__list">
              @for (touch of product.touches; track touch; let c = $index) {
                <div>
                  @if (b == 0) {
                    <h2>{{ touch.masterSuiteTouchName }}</h2>
                  }
                  <div
                    style="display: inline-flex; margin-bottom: 20px; margin-right: 10px"
                    >
                    @for (asset of touch.shootAssets; track asset; let d = $index) {
                      <app-qc-card
                        style="width: 380px; margin: 5px"
                        [isShootAsset]="true"
                        [data]="asset"
                        (editCallback)="editCallback($event, product.id)"
              (openImageCallback)="
                openImageCallback($event, product.id, a, b, c, d)
              "
                        (reviewCallback)="reviewCallback($event, asset)"
                      ></app-qc-card>
                    }
                  </div>
                </div>
              }
            </div>
          </div>
        }
        <mat-divider [ngStyle]="{ 'min-width': maxWidth + 'px' }"></mat-divider>
      </div>
    }
  </div>
}

@if (type == 'postAssets') {
  <div
    class="qc-view"
    #pdList
    (scroll)="onScroll($event)"
    >
    @for (masterSuite of dataSource; track masterSuite; let a = $index) {
      <div>
        <h1>{{ masterSuite.name }}</h1>
        @for (group of masterSuite.grouped; track group; let b = $index) {
          <div>
            <h2>{{ group.name }}</h2>
            @for (product of group.products; track product; let c = $index) {
              <div>
                <div class="product-info">
                  <span [class.product-info--missing]="!product.barcode">{{ product.barcode || '—' }}</span>
                  <span class="product-info__sep">·</span>
                  <span [class.product-info--missing]="!product.reference">{{ product.reference || '—' }}</span>
                </div>
                @if (type == 'postAssets') {
                  <div
                    class="product-details-page__list"
                    style="margin-bottom: 20px; margin-right: 10px"
                    >
                    @for (asset of product.postAssets; track asset; let d = $index) {
                      <app-qc-card
                        style="width: 380px"
                        [isShootAsset]="false"
                        [data]="asset"
                        (editCallback)="editCallback($event, product.productId)"
              (openImageCallback)="
                openImageCallback($event, product.productId, a, b, c, d)
              "
                        (reviewCallback)="reviewCallback($event, asset)"
                      ></app-qc-card>
                    }
                  </div>
                }
              </div>
            }
            <mat-divider [ngStyle]="{ 'min-width': maxWidth + 'px' }"></mat-divider>
          </div>
        }
      </div>
    }
  </div>
}
